import { render } from "./VideosDevices.vue?vue&type=template&id=6e575669"
import script from "./VideosDevices.vue?vue&type=script&lang=js"
export * from "./VideosDevices.vue?vue&type=script&lang=js"

import "./VideosDevices.vue?vue&type=style&index=0&id=6e575669&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__